import { createResource } from '@gandi/resource/redux';
import { createAction } from '../helpers';
export const resource = createResource('cart.suggestions.widget');
export const removeSuggestionOptimistic = createAction('remove suggestion');
export const fetchCartWidgetSuggestions = cartId => dispatch => dispatch(resource.fetch('/widgetsuggest/', {
  label: cartId,
  params: {
    cart: cartId
  }
}));